import React, { useEffect } from 'react';

interface ToastProps {
    message: string | null;
    onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, onClose }) => {

    useEffect(() => {
        const removeTimer = setTimeout(() => {
            onClose();
        }, 2000);

        return () => {
            clearTimeout(removeTimer);
        };
    }, [onClose]);

    return (
        <>
            {message &&
                <div style={{...toastStyle}}>
                    {message}
                </div>
            }
        </>
    );
};

const toastStyle: React.CSSProperties = {
    position: 'fixed',
    bottom: '102px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#000',
    color: '#fff',
    padding: '10px',
    borderRadius: '10px',
    opacity: 0.76
};

export default Toast;
